import { render, staticRenderFns } from "./HomeGenerico.vue?vue&type=template&id=ad844e9c&scoped=true&"
import script from "./HomeGenerico.vue?vue&type=script&lang=ts&"
export * from "./HomeGenerico.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad844e9c",
  null
  
)

export default component.exports